import { Avatar, Ellipsis } from 'antd-mobile'
import React, { useEffect, useRef, useState } from 'react'
import { ImageViewer } from 'antd-mobile'
import general, { redux } from '../../../../../general'
import Dialog from '../../../../../lib/Dialog'
import moment from 'moment'
import { BigPlayButton, ControlBar, Player, Shortcut } from 'video-react'
import Image from '../../../../../lib/Image'
import { NavLink } from '../../../../../lib/Navigation'
import NineSquareGrid from '../../../../community/NineSquareGrid'
import CommunityType from '../../../../community/CommunityType'
import CommunityAction from '../../../../community/CommunityAction'
import './css/CommunityItem.css'

export default function CommunityItem(props) {

  const propsItem = props?.item || {}
  const [item, setItem] = useState(propsItem)
  const [like, setLike] = useState(parseInt(item.me_like) === 1)
  const [like_count, setLike_count] = useState(item.like_count)
  const [reply] = useState(props.reply === true)
  const [isfootMark] = useState(props.isfootMark)
  const [playing, setPlaying] = useState(false)
  const [visible, setVisible] = useState(false)
  const [actionVisible, setActionVisible] = useState(false)
  const [contentImageUrls, setContentImageUrls] = useState([])
  const videoElementRef = useRef()
  const textContainer = useRef()
  const playerRef = useRef()

  const {
    index,
    currentVideoIndex,
    onPlayVideo,
    setVideoRef,
  } = props;

  useEffect(() => {
    setItem({ ...propsItem, reply_list: propsItem.reply_list || [] })
  }, [propsItem]);

  const likeAction = (e) => {
    if (like === true) {
      return
    }
    const tmp = {
      tagid: item.tagid,
      id: item.id,
      tab: parseInt(item.tagid) === 3 ? (reply ? 'answer' : 'question') : '',
      circles_type: item.circles_type ? item.circles_type : props.circles_type
    }
    general.axios.post('/likeUpvoteCommunity', tmp)
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setLike(true)
          setLike_count(parseInt(e) + 1)
          Dialog.toast({
            icon: 'agree',
            content: '',
            duration: 1,
            mask: false,
            onClose: () => { },
          });
        }
      })
  }

  const replyLikeAction = (obj, e) => {
    if (parseInt(obj.me_like) === 1) {
      return
    }
    const tmp = {
      tagid: e.tagid,
      id: obj.id,
      tab: parseInt(item.tagid) === 3 ? 'answer' : '',
      circles_type: props.circles_type
    }
    general.axios.post('/likeUpvoteCommunity', tmp)
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          obj.me_like = 1
          obj.like_count = parseInt(obj.like_count) + 1
          setItem({
            ...item,
            reply_list: e.reply_list
          })
        }
      })
  }

  const formatTime = (time) => {
    var date = new Date(time * 1000)
    let Y = date.getFullYear()
    let M = date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var time = Y + '-' + M + '-' + D
    if (time === moment().format('YYYY-MM-DD')) {
      return '今日 ' + H + m;
    } else if (time == moment().subtract(1, 'd').format('YYYY-MM-DD')) {
      return '昨日 ' + H + m;
    } else {
      return M + '月' + D + '日' + H + m
    }
  }

  useEffect(() => {
    if (playing) {
      playerRef.current?.video.play()
    } else {
      playerRef.current?.video.pause()
    }
  }, [playing])

  const headerDiv = (item) => {
    return (
      <div className="header">
        <NavLink to={!isfootMark ? '/user/record?id=' + item.user_id : ''}>
          <Avatar style={{ borderRadius: isfootMark ? '10px' : '20px' }} className='avatar' src={isfootMark ? item.game_info.game_image.source : reply ? item.user_logo : item.user_icon}></Avatar>
        </NavLink>
        <div className="name">
          <div className="username">{isfootMark ? item.game_info.game_name : item.user_nickname}
            {isfootMark && item.game_info.nameRemark ? <span className='name-remark'>{item.game_info.nameRemark}</span> : null}
            <img src={item.honor_icon} alt="" width={24} style={{ marginLeft: '5px' }} />
          </div>
          <div className="time">{(() => {
            if (isfootMark) {
              return item.game_info.game_classify_name + '｜ ' + formatTime(item.time)
            } else {
              return item.join_days + (reply ? ' • ' + formatTime(item.time) + ' • IP ' + (item.ip_location ? item.ip_location.province : '未知') : '')
            }
          })()}</div>
        </div>
        {item.is_ownself && <div style={{ display: 'flex', alignItems: 'center' }}>
          {parseInt(item.is_user_top) == 1 && <div style={{ backgroundColor: '#E3EEFF', borderRadius: 3, padding: '0 5px', fontSize: 10, color: '#72A9FF' }}>置顶</div>}
          <div onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            setActionVisible(true)
          }} style={{ display: 'flex', paddingLeft: 20 }}><img src="resources/251009/action.png" alt="" height={11} /></div>
        </div>}
        <div className='gold' style={{ display: parseInt(item.reward_intergral_amount) > 0 ? '' : 'none' }}>
          <img className='icon' src={'resources/251009/' + (parseInt(item.tagid) === 1 ? 'amount_comment.png' : 'amount_strategy.png')} />
          <div className='number' style={{ color: parseInt(item.tagid) === 1 ? '#DE274E' : '#7CC52D' }}>奖励{parseInt(item.reward_intergral_amount)}金币</div>
        </div>
      </div>
    )
  }

  const contentDiv = (item) => {
    return (
      <div ref={textContainer} className='content' style={{ paddingTop: item.title ? '4px' : '8px' }}>{item.content}</div>
    )
  }

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState()
      if (state.community_like_number_id) {
        if (parseInt(item.id) === parseInt(state.community_like_number_id)) {
          setLike_count(state.community_like_number)
          setItem({ ...item, like_count: state.community_like_number, me_like: 1 })
          setLike(true)
        }
      }
    })

  }, []);

  const replyContentDiv = (item) => {
    return (
      <Ellipsis
        className='reply-content'
        rows={3}
        direction='end'
        content={item.content}
        expandText='查看全文'
        collapseText='点击收起'
        onExpand={ellipsis => {
          // Toast.show(`${ellipsis ? '展开' : '收起'}了`)
        }}
      />
    )
  }

  const tagsDiv = (item) => {
    if (parseInt(item.recover) == 2) {
      return <span style={{ color: '#60C6CD' }}>#回复</span>
    } else {
      if (parseInt(item.tagid) === 0 && isfootMark) {
        return <span style={{ color: '#99C14B' }}>#帖子</span>
      } else if (parseInt(item.tagid) === 1) {
        return <span style={{ color: '#99C14B' }}>#评论</span>
      } else if (parseInt(item.tagid) === 2) {
        return <span style={{ color: '#EB475F' }}>#攻略</span>
      } else if (parseInt(item.tagid) === 3) {
        return <span style={{ color: '#2C69EA' }}>#问答</span>
      } else if (parseInt(item.tagid) === 4) {
        return <span style={{ color: '#6167E0' }}>#活动</span>
      }
    }
  }

  const handlePlayerReady = (player) => {
    // 覆盖 Video.js 实例的 toggleFullscreen 方法，使其不执行任何操作
    player.actions.toggleFullscreen = () => {
      console.log('Fullscreen action blocked completely.');
    };
  };

  // 新增：Intersection Observer 回调
  const handleIntersection = (entries) => {
    const entry = entries[0];
    if (setVideoRef && playerRef.current.video) {  // 确保 player 存在
      if (entry.isIntersecting) {
        // 可选：进入视口时播放
        // playerRef.current.play();
        console.log('视频进入视口，可播放');
      } else {
        // 划出视口时暂停
        playerRef.current.pause();
        console.log('视频划出视口，暂停播放');
      }
    }
  };

  useEffect(() => {
    if (!videoElementRef.current) return;

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,  // 阈值：50% 可见时触发（可调整为 0.1 ~ 1.0）
      root: null,      // 默认视口，可指定 scroll 容器如 root: document.querySelector('.list-container')
      rootMargin: '0px'  // 可选：扩展/收缩边界
    });

    observer.observe(videoElementRef.current);  // 开始监听

    // Cleanup：组件卸载时停止监听
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <NavLink user={reply} key={item.id} className='community-item' onClick={() => {
      if (props.commentAction) {
        props.commentAction(item.id, item.user_nickname)
      }
    }}>
      <div className="community-item-container" style={{ padding: reply ? '0' : '0 15px' }}>
        {headerDiv(item)}
        <div style={{ paddingTop: item.title ? '8px' : '0' }}>
          {parseInt(item.reward_intergral_amount) > 0 && <div style={{ paddingRight: '5px', display: 'inline-block', position: 'relative', top: -1.5 }}>
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'var(--MainColor)', borderRadius: '3.5px', padding: '1px 4px' }}>
              <img src="resources/251009/youzhi.png" alt="" height={9} />
              <div style={{ padding: '0px 2px', color: 'white', fontSize: '10px', flexShrink: 0 }}>优质</div>
            </div>
          </div>}
          {item.title ? <span className='title'>{item.title}</span> : null}
        </div>
        <div style={{ paddingLeft: reply ? '50px' : '0' }}>{reply ? replyContentDiv(item) : contentDiv(item)}</div>
        {reply && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0 15px 50px' }}>
          <div style={{ backgroundColor: '#F5F6F8', fontSize: '11px', color: '#666', padding: '1px 8px', borderRadius: '9.5px' }}>回复</div>
          <NavLink onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            likeAction(like_count)
          }} style={{ display: 'flex', alignItems: 'center' }}>
            <img src={'resources/251009/' + (like ? 'like.png' : 'unlike.png')} alt="" height={16} />
            <div style={{ fontSize: 11, color: '#666', width: 20, paddingLeft: 5 }}>{like_count}</div>
          </NavLink>
        </div>}
        {item.video?.length > 0 &&
          <div ref={videoElementRef} className="video" onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            setPlaying(!playing)
            onPlayVideo(index)
          }}>
            <Player
              aspectRatio='16:9'
              height={'auto'}
              poster={item.video_img_url}
              ref={(element) => {
                playerRef.current = element;
                setVideoRef(index)(element); // 同时设置父组件的 ref
              }}
              onPlay={() => {
                setPlaying(true)
                // 额外保障：onPlay 时确保是当前播放的
                if (currentVideoIndex !== index) {
                  onPlayVideo(index);
                }
              }}
              onPause={() => setPlaying(false)}
              autoPlay={false}
              playsInline={true}
              videoId={item.video_img_url}
              src={item.video}
              preload="metadata"
            >
              <Shortcut></Shortcut>
              <BigPlayButton position='center'></BigPlayButton>
              <ControlBar disableDefaultControls={true}></ControlBar>
            </Player>
            <div className="playbtn" style={{ visibility: playing ? 'hidden' : '' }}>
              <img src={'resources/community/' + (playing ? 'pause.png' : 'playing.png')} alt="" />
            </div>
          </div>}
        {item.video?.length == 0 && <div>{item.circles_type == 'game' || (item.circles_type != 'game' && item.contentImageUrls?.length == 1) ?
          <div>
            {item.contentImageUrls?.length > 0 &&
              <div className="wap">
                <div onClick={e => {
                  e.stopPropagation()
                  e.preventDefault()
                  setContentImageUrls(item.contentImageUrls)
                  setVisible(true)
                }} className="img"><Image className={'image ratio_type' + item.contentImageUrls[0].ratio_type} src={item.contentImageUrls[0].thumb} alt="" />
                  {item.contentImageUrls?.length > 1 && <div className='number'>
                    <img src="resources/251009/number.png" alt="" style={{ height: 11, marginRight: 3 }} />
                    <div>{item.contentImageUrls.length}</div>
                  </div>}
                </div>
              </div>
            }
          </div> :
          <NineSquareGrid images={item.contentImageUrls}></NineSquareGrid>
        }</div>}
        {!reply && item?.circles_info && Object.keys(item?.circles_info).length > 0 && <CommunityType circles_info={item.circles_info} topic_id={item.maiyou_gameid}></CommunityType>}
        {!reply && <div className="bottom">
          <div className="ip">IP • {item.ip_location ? item.ip_location.province : '未知'}
            {isfootMark || (!isfootMark && item.circles_type == 'game' && item.is_all) ?
              <span className='iptype' style={{ paddingLeft: 5 }}>{tagsDiv(item)}</span> : null}
          </div>
          <div className="action">
            <NavLink user={true} onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              likeAction(like_count)
            }}>
              <div className="btn" >
                <img src={'resources/251009/' + (like ? 'like.png' : 'unlike.png')} width='17px'></img>
                <div className='number'>{like_count}</div>
              </div>
            </NavLink>
            <div className="btn">
              <img src='resources/251009/action-comment.png' width={16}></img>
              <div className='number'>{item.reply_count}</div>
            </div>
          </div>
        </div>}

        {item.reply_list?.length > 0 ?
          reply ?
            <div className="reply-container">
              {item.reply_list.map((obj, idx) => {
                return (
                  <div className='reply-item' key={obj.id + '_' + idx}>
                    <div className="userinfo">
                      <img className='logo' src={obj.user_logo} alt="" />
                      <div className='user-info-content'>
                        <div className='nickname'>{obj.user_nickname}</div>
                        <div className='desc'>{obj.join_days + ' • ' + formatTime(obj.time) + ' • IP • ' + (obj.ip_location ? obj.ip_location.province : '未知')}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => {
                        replyLikeAction(obj, item)
                      }}>
                        <img src={'resources/251009/' + (parseInt(obj.me_like) == 1 ? 'like.png' : 'unlike.png')} alt="" height={16} />
                        <div style={{ fontSize: 11, color: '#666', width: 20, paddingLeft: 5 }}>{obj.like_count}</div>
                      </div>
                    </div>
                    <div className="reply-content">{obj.content}</div>
                    {idx < item.reply_list.length - 1 ?
                      <div className='line'></div> : null}
                  </div>
                )
              })}
            </div> :
            <>
              <div className="reply">
                <span className='username'>{item.reply_list[0].user_nickname}:</span>
                <span className='reply-contents'>{item.reply_list[0].content}</span>
              </div>
            </> : null
        }

        <div style={{ backgroundColor: '#eee', height: 0.5 }}></div>
      </div>

      <ImageViewer.Multi
        classNames={{ mask: 'community-image-viewer' }}
        getContainer={document.getElementById('root')}
        images={contentImageUrls.map(e => e.source)}
        visible={visible}
        defaultIndex={0}
        onClose={() => {
          setVisible(false)
        }}
      />

      <CommunityAction visible={actionVisible} handleClose={() => setActionVisible(false)} item={item} />
    </NavLink>
  )
}
